import React from "react";

const AdminProductDashboard = () => {
  return (
    <div>
      <h2>Products Dashboard</h2>
      <h3>As An admin you can modify products, use the navigation above</h3>
      <p>
        If I have time, I would create a proper admin dashboard here, but if you
        can still see this, I was too busy coding something else!
      </p>
    </div>
  );
};

export default AdminProductDashboard;
